<template>
<div class="chapter">
<div class="inner_page">
<div id="Chapter-Three.html" xml:lang="en-US">
<div class="Basic-Text-Frame-27">
<p class="ch"><a id="Anchor-1"></a>CHAPTER THREE</p>
<p class="body-text-opening"><span class="sc" xml:lang="en-US">C</span><span class="sc-epub" xml:lang="en-US">OLE</span><span class="sc" xml:lang="en-US"> </span><span class="sc-epub" xml:lang="en-US">GLARED</span><span class="sc" xml:lang="en-US"> </span><span class="sc-epub" xml:lang="en-US">AT</span><span class="sc" xml:lang="en-US"> </span><span class="sc-epub" xml:lang="en-US">THE</span><span class="sc" xml:lang="en-US"> </span><span class="sc-epub" xml:lang="en-US">TOP</span> of his physical therapist’s
					head, cursing her for an ogre and a devil and a nasty, power-abusing son of a
					bitch. Farrah looked up and smiled. “You doing okay, Cole?” She pressed his knee
					tighter to his ribs, resting all her weight against it. Not much heft
					considering she had the size and appearance of a benevolent fairy. Just another
					of her evil tricks.</p>
<p class="body-text">“I’m great,” he ground out between clenched teeth.</p>
<p class="body-text">“Easy says you’re bugging the tar out of him again.”</p>
<p class="body-text">“I need to get back to work.”</p>
<p class="body-text">“You want this to heal right or not?” She finally released his
					knee, but his hip joint screamed as she slowly lowered his leg to the
					ground.</p>
<p class="body-text">“It’s healing fine,” he said.</p>
<p class="body-text">Her eyes slid away. “You’re strong and healthy. You were in
					excellent shape before the accident, but there’s still a chance…”</p>
<p class="body-text">“Sure.”</p>
<p class="body-text">“When are you going back to the orthopedist?”</p>
<p class="body-text">“Two weeks.”</p>
<p class="body-text">“Okay.” She stood up, dusting her hands as if Cole were a pet
					project. “I bet a new CT scan will have more answers. But I can definitely tell
					you’ve been doing the exercises.”</p>
<p class="body-text">He stood and stretched his back. “Thanks for coming by this
					morning. I know you don’t have to do that.”</p>
<p class="body-text">“You’re a special case.” She rolled her eyes, but then smiled
					brightly. “Really, Cole. I want to help you get back in the saddle as much as
					Easy does.”</p>
<p class="body-text">“Oh, yeah? Your uncle isn’t offering much help.”</p>
<p class="body-text">“You mean he’s following doctor’s orders because you
					won’t?”</p>
<p class="body-text">“Jesus, I haven’t ridden, have I?” Cole grimaced as he realized
					he’d snapped at this girl who was like a little cousin to him. “Sorry,
					Farrah.”</p>
<p class="body-text">“Please. You wouldn’t believe the things I hear from my
					clients. Combinations of words that I shouldn’t even know.” She grabbed her bag.
					“Take a hot shower. Loosen everything up. And you’re making progress.”</p>
<p class="body-text">“Sure,” he murmured as he gave her a farewell hug and let her
					out the door.</p>
<p class="body-text">He was doing great. Of course he was. Despite what the experts
					were saying, he was sure he’d be fine.</p>
<p class="body-text">As fine as could be expected for a cowboy who might never ride
					again.</p>
<p class="body-text">Cole shook his head and ran a hand over his sore thigh. He’d be
					okay. The doctors were hopeful. The shattered femur was healing and the pelvic
					fracture would mend. Just in time for him to get back out there to round up the
					stock for fall.</p>
<p class="body-text">It would be his last roundup for Easy. Oh, he loved Easy like a
					father, but Cole was ready to own his own ranch. And Easy was ready to sell.
					Next year, Cole would be rounding up his own cattle, and Easy would be sipping
					piña coladas on a Mexican beach.</p>
<p class="body-text">Chuckling at the thought of Easy relaxing on a beach in his
					Stetson, Cole headed for the shower.</p>
<p class="body-text">He made the water as hot as he could stand it, hoping no one
					else in the building had put too much of a strain on the water heater. One of
					these days he’d do his exercises, take a hot shower and suddenly feel good.
					Great. Back to normal. He knew it. But for now, the ache hadn’t left. Sometimes
					it faded to something bearable. Sometimes it swelled into a giant thumping heart
					in his thigh. The pain was normal, his doctors said. Nothing to be concerned
					about.</p>
<p class="body-text">Half an hour later, the ache beaten back to a dull roar, Cole
					found himself sipping his morning coffee and staring at his door again, waiting
					for some sign of life from the apartment across the hall.</p>
<p class="body-text">He hadn’t seen her since he’d watched her talk to Rayleen at
					the saloon. Grace hadn’t even noticed him over in the alcove that housed the
					pool tables. He’d been half irritated by that, and half thankful that he’d
					gotten the chance to watch her openly.</p>
<p class="body-text">She was a small woman, with delicate bones, but she held her
					body as though she was coiled to flee at any moment. Or pounce, maybe. He hoped
					it was the latter.</p>
<p class="body-text">But as intriguing as she was, she seemed to have disappeared.
					He hadn’t heard her even once, and they shared a common wall along the hall and
					bathroom. Jackson was pretty quiet at night, and he’d often heard his previous
					neighbor moving around, but Grace was silent as a mouse.</p>
<p class="body-text">Of course, the previous tenant was a drunken college dropout
					whose number one hobby had been juggling three different girlfriends. At least
					it had given Cole a soap opera to listen to on sleepless nights.</p>
<p class="body-text">But where was his new neighbor?</p>
<p class="body-text">Maybe the deal had fallen through. Maybe Old Rayleen had
					somehow been under the impression that she was renting the place to a hot
					nephew. Though… Cole shook his head at the wrongness of that thought.</p>
<p class="body-text">The old woman was harmless. Eccentric, but harmless. Even the
					jokes in town meant nothing, which was why everyone thought they were funny.
					Obviously nothing was going on between Rayleen and her young renters, but with
					the house being part of the old Studd homestead, the jokes were too easy. Too
					damn perfect.</p>
<p class="body-text">And she really never did seem to rent to women.</p>
<p class="body-text">Cole heard a car door close outside and cocked his head,
					waiting to see if it was Grace returning from… Where? A boyfriend’s house? A
					very, very late night with a new acquaintance? He found himself slightly
					irritated at the thought, and couldn’t help but smile at his own stupidity. That
					woman was all passion and attitude. If she wanted to sleep with a different guy
					every night, she damn sure would, and there’d be no apologies either. He’d be a
					fool to let it get to him.</p>
<p class="body-text">Raising his cup to his lips, he realized it was empty. He
					wanted to have another one, but somehow one cup of coffee made his leg feel
					better and two made it feel worse. And it was already primed for feeling sore as
					hell today, between working the day before and physical therapy this
					morning.</p>
<p class="body-text">Even during the worst of it, just after surgery, he hadn’t been
					expecting that. That the pain would be so overwhelming. That the injury might be
					so bad he’d never ride again. He’d been on a horse since he was three. It felt
					more natural to him than walking. And now, now it felt as though his muscles
					couldn’t quite remember the way to walk naturally, much less direct a horse with
					the barest of tension. But his muscles weren’t really the problem. The problem
					was the crack that went from his hip joint and halfway up his pelvis. With the
					shattered femur and the metal holding all that together…</p>
<p class="body-text">“We’re going to have to see,” they’d said. “You could do
					permanent damage in a saddle.”</p>
<p class="body-text">But Cole couldn’t accept that. He didn’t know how to accept
					it.</p>
<p class="body-text">He’d been completely out of work for eight months, and he’d
					been cleared to work half days only a month before. But for a cowboy, a half day
					should’ve been eight hours, with no such thing as a weekend. Cole didn’t know
					what the hell to do with himself.</p>
<p class="body-text">It was worse now that he was up and around. He was at the ranch
					most days, watching his old friends do the things he couldn’t do. Cole was
					relegated to the yard and corrals, limping from job to job until Easy told him
					his four hours were up and he had to leave.</p>
<p class="body-text">Four hours a day, five days a week. It was shameful. And how
					was he supposed to be ready for the roundup when he wasn’t allowed to push
					himself?</p>
<p class="body-text">He wasn’t supposed to go in today, but if he snuck into the
					tack house and worked a few hours on repairs while everyone else was out
					checking cattle, he could sneak out before lunchtime. Hell, Easy wouldn’t know
					anything about it. Cole wouldn’t get paid, but this wasn’t about the money. It
					was about being where he belonged, doing something useful. And getting his body
					ready to get back to work full-time.</p>
<p class="body-text">The front door hadn’t opened yet, so Cole assumed the car had
					been stopping at another house. Which still left the mystery of his new
					next-door neighbor. He eyed the coffeepot, then the clock. He still had two
					hours to waste before he could safely sneak onto the ranch.</p>
<p class="body-text">So, what the hell? A little curiosity never hurt anyone.</p>
<p class="body-text">He laughed at that. Curiosity had nearly ruined him once. But
					he’d been a boy then. Stupid and easily controlled by his sense of adventure.
					And his dick. One and the same, sometimes, and not exactly a moot point when it
					came to curiosity either.</p>
<p class="body-text">After all, Grace was beautiful.</p>
<p class="body-text">Well, not beautiful. That wasn’t the word. Not pretty either.
					Or cute. Not with that wild, choppy hair in chunks of brown and black and
					purple. And those dark eyes that looked like they absorbed everything and let
					nothing show through. And her pale, flawless skin. She wasn’t pretty—she was
					striking. Like a kick to the gut. And he hadn’t felt that since…</p>
<p class="body-text">Hell, he hadn’t felt that since he was an idiot boy getting his
					first taste of a girl from the big city. So maybe he hadn’t grown up so much
					after all.</p>
<p class="body-text">But regardless of where she was from, this wasn’t L.A. and he
					wasn’t signing up for a life of debauchery. He was just checking on a
					neighbor.</p>
<p class="body-text">So, Cole stood up—purposefully not pressing a hand to his thigh
					as it screamed—and walked out to knock on her door.</p>
<p class="body-text">The silence that followed wasn’t a good sign. Eight o’clock was
					late by his standards, but too early for a girl like her, maybe. But the more
					likely truth was that she wasn’t there. She’d disappeared as quickly as she’d
					shown up. Seemed about right. Rayleen had sent Grace on her way. Those two would
					probably get along like a couple of feral cats.</p>
<p class="body-text">Convinced that the place was just as empty as it had been two
					days before, Cole started to leave, only to swing back around when a muffled
					voice interrupted the silence. “Who is it?”</p>
<p class="body-text">“It’s Cole,” he said, a smile springing so quickly to his face
					that it startled him. When she didn’t respond, he added, “Your neighbor.”</p>
<p class="body-text">The door opened. Not all the way, of course, just enough to
					reveal Grace standing there glaring at him.</p>
<p class="body-text">“Good morning,” he offered, his eyes dipping to take her in.
					She was dressed in jeans and a black hoodie, but her feet were bare, aside from
					the deep blue polish on her toenails.</p>
<p class="body-text">“Somebody painted over the peephole,” she muttered, running a
					hand through her crazy hair. It stood up in wild layers that somehow made her
					look younger. Or maybe that was the faded, smeared makeup. But he noticed that
					her lips were still a deep pink color, even first thing in the morning. That
					wasn’t lipstick. That was just the sweet shade of her mouth.</p>
<p class="body-text">“The what?” he finally remembered to ask.</p>
<p class="body-text">“The peephole,” she gestured at the door.</p>
<p class="body-text">“Oh.” He looked over his shoulder at his own door. “I guess I
					never noticed.”</p>
<p class="body-text">“I guess you wouldn’t. Did you need something?”</p>
<p class="body-text">“No. I just wanted to check on you.”</p>
<p class="body-text">“Me?” Her eyes narrowed. “Why?”</p>
<p class="body-text">“Well, we’re neighbors. And I hadn’t heard so much as a door
					shut since I saw you yesterday. I thought maybe Old Rayleen had sent you on your
					way.”</p>
<p class="body-text">She started to shake her head, and then seemed to be caught by
					surprise by a huge yawn. Her hand clutched the edge of the door and swung it
					farther open. The place looked the same as yesterday. Not one piece of furniture
					or sign of life. The kitchen was dark and quiet.</p>
<p class="body-text">Cole was craning his neck to look around her when Grace seemed
					to realize what he was doing and narrowed the opening. But he’d seen enough.
					None of her stuff was here yet.</p>
<p class="body-text">“Want a cup of coffee?”</p>
<p class="body-text">For a second, her dark, fathomless eyes flared with emotion.
					Something close to lust.</p>
<p class="body-text">“It’s already brewed,” he coaxed.</p>
<p class="body-text">“Mmm.” She glanced toward his door, and he knew she was hoping
					he’d offer to bring her a cup and leave her alone. Fat chance.</p>
<p class="body-text">“Come on. We can leave my front door open, since I make you
					nervous.”</p>
<p class="body-text">“Ha!” Her laugh was rusty and gorgeous. “Why would <em class="italic">you</em> make me nervous?”</p>
<p class="body-text">Cole wasn’t sure he liked the emphasis she’d put on <em class="italic">you,</em> but he just smiled. “No idea. But I obviously
					do.”</p>
<p class="body-text">“That’s not nervousness, cowboy. It’s called being smart enough
					not to get behind closed doors with a strange man.”</p>
<p class="body-text">“Strange, huh? I hope you haven’t been listening to the stories
					about me. Half of them aren’t even true.”</p>
<p class="body-text">“You wouldn’t know strange if it bit you on the ass,” she said,
					but she waved him back and stepped into the hall with a small smile. “Are you
					going to give me coffee or not?”</p>
<p class="body-text">“Yes, ma’am,” he drawled, tipping an imaginary hat before he
					moved across the hall to open his door. “I was just about to have breakfast,” he
					lied. He’d eaten almost two hours before, but she didn’t seem to have done much
					shopping yet. “Will you eat bacon and eggs? If you’re a vegetarian, I can whip
					up some toast.”</p>
<p class="body-text">She didn’t answer for a few seconds. Cole heard her close the
					door softly as he headed for the coffeepot.</p>
<p class="body-text">“Bacon and eggs would be great,” she finally said. “And toast,
					too, if you’re offering.”</p>
<p class="body-text">“Sure.” He poured her coffee and refilled his own cup. What the
					hell. A little aching in his thigh was worth spending some time with her. He
					didn’t have anything else interesting going on. And it wouldn’t be the first
					time he’d endured aching for an attractive woman.</p>
<p class="body-text">Cole put sugar and milk out on the counter, tossed a pan on a
					burner and grabbed the bacon and eggs. He felt her gaze on his back as he
					worked. “Over easy okay?” he asked as he laid bacon on the cast iron.</p>
<p class="body-text">“Great,” she answered. “You look like you know what you’re
					doing.”</p>
<p class="body-text">He glanced back to find her seated on a stool, hunched over her
					coffee as if she was cold. Mornings were chilly up here if you weren’t from the
					mountains. He reached past the fridge to turn up the thermostat. “We all take
					turns cooking in the bunkhouse.”</p>
<p class="body-text">“Oh, the bunkhouse,” she said, making the word sound
					mysterious. There was nothing mysterious about it, unless you thought cooking
					and sleeping in what was essentially a live-in locker room was mysterious.</p>
<p class="body-text">“So what are you doing here?” she asked. “Did you get tired of
					bunkhouse living?”</p>
<p class="body-text">Hell, yeah, he was tired of bunkhouse living, but that hadn’t
					been the problem. As a matter of fact, he’d become ranch boss and moved into the
					boss’s house less than a year before.</p>
<p class="body-text">Cole finished frying the bacon, then set it on a plate and
					covered it before breaking the eggs into the hot grease. “I was hurt last year,”
					he finally said.</p>
<p class="body-text">“What happened?”</p>
<p class="body-text">“A horse landed on my leg.”</p>
<p class="body-text">“Ow.”</p>
<p class="body-text">“Yeah.” He wanted to reach down and rub his leg, but he
					concentrated on the eggs instead.</p>
<p class="body-text">“So they made you move out?”</p>
<p class="body-text">The whole complicated story loomed before him. Cole rolled his
					shoulders. “There’s not enough room for guys who aren’t working, so, yeah. But
					I’m getting back to work now. I won’t be here much longer.”</p>
<p class="body-text">“Me either.”</p>
<p class="body-text">He put bread in the toaster. “You just got here.”</p>
<p class="body-text">“I’m passing through.”</p>
<p class="body-text">Cole blinked at that, tension tightening his shoulders, but he
					tried not to let it show. “Who could’ve guessed you didn’t want to settle in
					Wyoming?”</p>
<p class="body-text">One of her perfectly sculpted eyebrows rose. “You telling me I
					don’t look like a Wyoming girl?”</p>
<p class="body-text">“You know damn well you don’t look like a Wyoming girl. And
					that’s the way you like it.”</p>
<p class="body-text">Now both eyebrows rose as if she was surprised. Cole piled two
					plates high with eggs and bacon and toast. He slid the plates across the
					counter, added forks and knives and paper towels, and joined her at the
					barstools to find out exactly who she was.</p>
<p class="tb">* * *</p>
<p class="body-text-no-tab"><span class="sc" xml:lang="en-US">T</span><span class="sc-epub" xml:lang="en-US">HE</span><span class="sc" xml:lang="en-US"> </span><span class="sc-epub" xml:lang="en-US">MAN</span><span class="sc" xml:lang="en-US"> </span><span class="sc-epub" xml:lang="en-US">WAS</span><span class="sc" xml:lang="en-US"> </span><span class="sc-epub" xml:lang="en-US">SMARTER</span> than he looked. She’d been trying to bait
					him, force him to say something that she’d find insulting. Instead he’d spoken
					the truth as if it were obvious to him. Grace wasn’t sure what to do with
					that.</p>
<p class="body-text">“So how long are you staying?” he asked.</p>
<p class="body-text">She took a bite of egg instead of answering his question. The
					flavor melted over her tongue and she hoped Cole didn’t hear the way her stomach
					growled at the sudden pleasure. “Wow. The eggs are amazing.”</p>
<p class="body-text">“Bacon grease,” he said. “What are you doing out here?
					Working?”</p>
<p class="body-text">Grace cleared her throat and told herself not to stuff the food
					into her mouth, but damn, she hadn’t had a real meal in days. On the bus, it had
					been granola bars and chips. She took a bite of bacon and spoke past it. “I
					already told you. I’m passing through.”</p>
<p class="body-text">“On your way to where?”</p>
<p class="body-text">“Vancouver.”</p>
<p class="body-text">“Oh.” He smiled. “This is a strange route to Vancouver.”</p>
<p class="body-text">She shrugged and made a point of changing the subject. “Thanks
					so much for breakfast. And coffee. The coffee’s great, too. Strong.”</p>
<p class="body-text">She felt his gaze on her, but caught the movement of his head
					when he finally looked away. “You should try it after it’s been sitting at the
					edge of a campfire all day. That’ll wake you up.”</p>
<p class="body-text">She was glad he’d given up the questions, because she wanted to
					grab her plate and run back to her place so she could shovel the food in the way
					she wanted to. If he pushed her anymore, that’s exactly what she’d do. But he
					dropped the subject, so she slathered too much butter on the toast and managed
					to get nearly a fourth of it into her mouth in one bite.</p>
<p class="body-text">God, she’d been really hungry. Now she wanted to groan in
					pleasure. Maybe he wasn’t so bad. As a matter of fact, at this moment, Cole
					Rawlins was pretty awesome.</p>
<p class="body-text">She didn’t register how many eggs were on her plate until she
					dug into the third one. “How many eggs did you make?” she asked.</p>
<p class="body-text">“Four for you, four for me.”</p>
<p class="body-text">She laughed. “Do I look like I eat as much as you do?”</p>
<p class="body-text">“You look like you’re doing okay, actually.”</p>
<p class="body-text">Grace laughed so hard she almost had to stop eating for a
					moment. “Didn’t I tell you I was a lumberjack back in L.A.?”</p>
<p class="body-text">“Ah. Of course. You’ve got that look about you.”</p>
<p class="body-text">Jesus, he was funny. A funny cowboy. Who’d have thunk it. She’d
					thought they were all silent and brooding. Hell, they’d all definitely been
					silent and brooding in <em class="italic">Brokeback Mountain.</em> But she
					tried not to think about that when she looked at Cole.</p>
<p class="body-text">“So, you’re from L.A.”</p>
<p class="body-text">“Unfortunately.”</p>
<p class="body-text">“What do you do for a living?”</p>
<p class="body-text">“Nothing right now.”</p>
<p class="body-text">“Did—”</p>
<p class="body-text">“I think I’m getting full,” she interrupted with an apologetic
					wince. “Want my last egg?”</p>
<p class="body-text">“No, I’m full myself.” He reached for the plate, but Grace
					couldn’t quite bear to let it go, so she snatched the last piece of bacon before
					he could whisk it away. He put the plate back down. Full or not, her mouth still
					watered when she bit into the bacon. She tried not to think about how long it
					had been since her last hot meal. It didn’t matter. She’d get a job today. Or
					the next day. She’d have a check within a week. She’d start paying back the
					money she owed so she’d never have to think about her ex again.</p>
<p class="body-text">“You want help moving in?” Cole asked.</p>
<p class="body-text">“No, I’m fine.” Now that she was full, Grace really needed to
					escape. He kept asking the wrong kinds of questions. Not that there were any
					right questions. Not about her.</p>
<p class="body-text">“Come on.”</p>
<p class="body-text">“I don’t have much.” Or anything. “Anyway, you’re injured.”</p>
<p class="body-text">“I think I can handle moving a futon.” He gestured as he said
					that, and Grace could see he was right. His hands were wide, and scars stood out
					white against the tan. And she was pretty sure she’d never seen such <em class="italic">nice</em> forearms. Assuming one thought thick and muscled
					and masculine was nice. She had a brief temptation to touch his arm, to see if
					the hair was crisp or soft.</p>
<p class="body-text">“So you’ll let me help?” he pressed.</p>
<p class="body-text">Shit. She hopped off the stool and edged toward the door, away
					from him and his questions. “I’m good. But thank you for the breakfast. And
					coffee.” She forced herself not to ask for another cup, but it was hard. She’d
					already taken too much from this man. “I’ll see you around.”</p>
<p class="body-text">“Hey.”</p>
<p class="body-text">She stopped halfway out the door, but only because he’d fed
					her. Anybody else and she would’ve kept walking. When he didn’t say anything,
					she stuck her head back in to see him writing something down.</p>
<p class="body-text">“Here’s my phone number,” he said when he crossed the room.</p>
<p class="body-text">She didn’t reach for it, feeling immediately wary. “You live
					across the hall. I think I can find you if I need you.”</p>
<p class="body-text">“You know anybody here except Rayleen?”</p>
<p class="body-text">She met his pale eyes and didn’t answer. <em class="italic">Yes, I’m alone and vulnerable. Good for you to know.</em></p>
<p class="body-text">“This isn’t L.A.” he said. “If you get stuck somewhere at night
					or your car breaks down in the middle of nowhere, you might not see another car
					for an hour. So, take my number, all right?”</p>
<p class="body-text">No, this definitely wasn’t L.A. And if he thought she was
					afraid of something like being alone for an hour, then he didn’t know what real
					fear was.</p>
<p class="body-text">But he took one step closer and pressed the paper into her
					hand. When her fingers closed over it, he winked. “In case you need me,” he said
					again, this time with a hint of amusement.</p>
<p class="body-text">Grace nodded. “All right. I’ll call you if I have any cows that
					need branding, stud.”</p>
<p class="body-text">“Stud? My God, you L.A. women are forward. I think I’m
					blushing.”</p>
<p class="body-text">She closed the door in his face, and scowled at his laughter as
					she crossed the hall.</p>
<p class="body-text">Did he think she’d been flirting with him? He probably did
					think that. He was undeniably handsome, though totally not her type. Too
					clean-cut. Too chiseled and… Okay, he was pretty fantastic-looking, but too
					confident for his own good. He probably thought she’d add a little exotic
					city-girl spice to his bed. And he probably thought he’d have no trouble getting
					her there. But Grace wasn’t interested in being his little curiosity. Even if
					she had any interest in getting laid right now—and she didn’t—she wasn’t going
					to be his experiment in edginess. His walk on the wild side. He could just sit
					over there and wonder.</p>
<p class="body-text">Wanting to get the coffee taste out of her mouth, Grace headed
					toward the bathroom, where she’d already unloaded her few supplies and one giant
					box of cosmetics. But when she flipped on the light and got a look at herself,
					she froze. She’d forgotten to take off her makeup last night, and it had smeared
					into a crooked mask around her eyes. She suddenly had to consider that Cole’s
					laughter hadn’t been flirtation at all. Maybe it had just been pure
					amusement.</p>
<p class="body-text">Damn.</p>
<p class="Basic-Paragraph-21"></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter_Three.vue?23e8cd0a